import { storeToRefs } from 'pinia';
import { AppCoreEnums } from '../shared/enums';
import { useCoreStore } from '../../stores/core/store';
import useConfirmation from '../composable/use-confirmation';

export default () => {
  const coreStore = useCoreStore();
  const { showConfirmation } = useConfirmation();
  const { formContainerData } = storeToRefs(useCoreStore());

  const saveFormAsync = async () => {
    try {
      await askAndDoSaveIfNeeded();
      return true;
    } catch {
      return false;
    }
  };

  const askAndDoSaveIfNeeded = (): Promise<void> => {
    return new Promise<void>((resolve, reject) => {
      coreStore.formContainerData.savePromise = undefined;

      if (formContainerData.value.isDirty && !formContainerData.value.isFormModelDeleted) {
        showConfirmation('core.confirmLeaveDirtyPage', 'core.confirmation', true).then((res) => {
          switch (res) {
            case AppCoreEnums.ConfirmationResult.Yes:
              formContainerData.value.requestSave({ resolve, reject });
              break;
            case AppCoreEnums.ConfirmationResult.No:
              formContainerData.value.isDirty = false;
              resolve();
              break;
            case AppCoreEnums.ConfirmationResult.Cancel:
              reject();
              break;
          }
        });
      } else {
        resolve();
      }
    });
  };

  return {
    saveFormAsync,
  };
};
